import React, { useEffect, useState } from "react";
import { GetAllEvents } from "../utils/Api/ApiCalls";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";

const Tracker = () => {
  const [trakerData, setTrackerData] = useState([]);
  const [eventsByTime, setEventsByTime] = useState({});
  const itemsPerPage = 5;
  const [selectedEmails, setSelectedEmails] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [temp, setTemp] = useState([]);

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = trakerData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(trakerData?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % trakerData.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    getEvents();
  }, []);
  const getTracker = async () => {
    const trackerData = await GetAllEvents();
    // const waData = eventsData.filter((event) => {
    //   return event.eventName.toLowerCase() === "whatsapp";
    //   });
    
  };

  const getEvents = async () => {
    const eventsData = await GetAllEvents();
    const now = new Date();

    // Sort events by timestamp in descending order (most recent first)
    const sortedEventsData = eventsData?.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

    // Filter WhatsApp events
    const waData = sortedEventsData?.filter((event) => 
        event.eventName?.toLowerCase() === "whatsapp"
    );

    // Helper functions for date comparisons
    const isSameDay = (date1, date2) => 
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();

    const isSameWeek = (date1, date2) => {
        const startOfWeek = new Date(date2);
        startOfWeek.setDate(date2.getDate() - date2.getDay()); 
        startOfWeek.setHours(0, 0, 0, 0);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6); 
        endOfWeek.setHours(23, 59, 59, 999);

        return date1 >= startOfWeek && date1 <= endOfWeek;
    };

    const isSameMonth = (date1, date2) => 
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth();

    const eventsByTime = {
        today: [],
        thisWeek: [],
        thisMonth: [],
    };

    waData?.forEach(event => {
        const eventDate = new Date(event.timestamp);
        
        if (isSameDay(eventDate, now)) {
            eventsByTime.today.push(event);
        }
        
        if (isSameWeek(eventDate, now)) {
            eventsByTime.thisWeek.push(event);
        }

        if (isSameMonth(eventDate, now)) {
            eventsByTime.thisMonth.push(event);
        }
    });
    
    setTrackerData(sortedEventsData); // Set sorted events
    setEventsByTime(eventsByTime);
};



  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const onSearch = () => {
    let data = temp.filter(
      (item, i) =>
        item.Amount.toString().includes(searchTerm) ||
        item.PaymentMethod.includes(searchTerm)
    );

    setTrackerData(data);
  };

  return (
    <section class="content-main">
      <div class="content-header">
        <h2 class="content-title">Tracker - WhatsApp</h2>
      </div>
       <div class="row">
                <div class="col-lg-3">
                  <div class="card card-body mb-4">
                    <article class="icontext">
                      <span class="icon icon-sm rounded-circle bg-primary-light">
                      <script src="https://unpkg.com/ionicons@4.5.10-0/dist/ionicons.js"></script>
                      </span>
                      <div class="text">
                        <h6 class="mb-1 card-title">All time</h6>
                        {/* <span>$13,456.5</span> */}
                        <span>{trakerData?.length}</span>
                        {/* <span class="text-sm"> All time </span> */}
                      </div>
                    </article>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="card card-body mb-4">
                    <article class="icontext">
                      <span class="icon icon-sm rounded-circle bg-success-light">
                      <ion-icon name="calendar"></ion-icon>
                      </span>
                      <div class="text">
                        <h6 class="mb-1 card-title">This month</h6>
                        {/* <span>53.668</span> */}
                        <span>{eventsByTime?.thisMonth?.length}</span>
                        {/* <span class="text-sm"> Excluding orders in transit </span> */}
                      </div>
                    </article>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="card card-body mb-4">
                    <article class="icontext">
                      <span class="icon icon-sm rounded-circle bg-warning-light">
                      <ion-icon name="calendar"></ion-icon>
                      </span>
                      <div class="text">
                        <h6 class="mb-1 card-title">This week</h6>
                        {/* <span>9.856</span> */}
                        <span>{eventsByTime?.thisWeek?.length}</span>
                        <span class="text-sm">
                          {/* In {eventsByTime.thisWeek.length} Categories */}
                        </span>
                      </div>
                    </article>
                  </div>
                </div>
      
                <div class="col-lg-3">
                  <div class="card card-body mb-4">
                    <article class="icontext">
                      <span class="icon icon-sm rounded-circle bg-info-light">
                      <ion-icon name="today"></ion-icon>
                      </span>
                      <div class="text">
                        <h6 class="mb-1 card-title">Today</h6>
                        {/* <span>₦6,982</span> */}
                        <span>{eventsByTime?.today?.length}</span>
                        <span class="text-sm"> </span>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              {/* <header class="border-bottom mb-4 pb-4">
                <div class="row">
                  <div class="col-lg-5 col-6 me-auto">
                    <input
                      type="text"
                      placeholder="Search by Amount, payment method."
                      class="form-control"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      onKeyUp={onSearch}
                    />
                  </div>
                </div>
              </header> */}

              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Customer Name</th>
                      <th>Component</th>
                      <th>Event</th>
                      <th>Created Date</th>
                      {/* <th class="text-end">Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems?.length > 0 ? (
                      currentItems?.map((item, i) => (
                        <tr key={"request x" + i}>
                          <td>
                            <b>{item?.user?.fullName}</b>
                          </td>
                            <td>{item?.component}</td>
                          <td>
                            {/* <div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/1.png'
														alt='Payment'
													/>
													<span class='text text-muted'>{item.PaymentMethod}</span>
												</div> */}
                            {item?.eventName}
                          </td>
                          <td>{new Date(item.timestamp).toDateString()}</td>

                          {/* <td class="text-end">
                            <Link
                              to={`/transaction/details/${item.TransactionId}`}
                              class="btn btn-sm btn-light font-sm rounded"
                            >
                              Details
                            </Link>
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>No Click yet...</tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination-area mt-30 mb-50">
        <nav aria-label="Page navigation example">
          <ReactPaginate
            nextLabel="Next"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            previousLabel="Previous"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link w-auto"
            nextClassName="page-item"
            nextLinkClassName="page-link w-auto"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination justify-content-start"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        </nav>
      </div>
    </section>
  );
};

export default Tracker;

const toProperCase = (text) => {
  return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
};
